module.exports = __webpack_public_path__ + "img/credit_blue_darken_icon.3b6ec22c.svg";